import { render } from "./ModalContainer.vue?vue&type=template&id=ede218ae&lang=pug"
import script from "./ModalContainer.vue?vue&type=script&setup=true&lang=js"
export * from "./ModalContainer.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__